import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2eb541ee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2eb541ee&scoped=scoped&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=2eb541ee&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb541ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb541ee')) {
      api.createRecord('2eb541ee', component.options)
    } else {
      api.reload('2eb541ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2eb541ee&scoped=true&", function () {
      api.rerender('2eb541ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/audioNotice/index.vue"
export default component.exports